module.exports = __webpack_public_path__ + "7ab9c8977dcbe46e94783fc0885c6de0.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/carousel/components/images/error.jpg
 ** module id = 1496
 ** module chunks = 0
 **/